module.exports = __webpack_public_path__ + "static/media/Klim-Kideshim.b1953aaf.jpeg";